var _effectorFileName = "/builds/gmini/front-utils/src/declensionsOfNum.ts";
export var declensionsOfNum = function declensionsOfNum(number, text_forms) {
  var newNumber = Math.abs(number) % 100;
  var number1 = newNumber % 10;

  if (newNumber > 10 && newNumber < 20) {
    return text_forms[2];
  }

  if (number1 > 1 && number1 < 5) {
    return text_forms[1];
  }

  if (number1 === 1) {
    return text_forms[0];
  }

  return text_forms[2];
};